const Language = {
  id: {
    label: "Indonesia",
    flag: window.location.origin + "/assets/images/flags/inflag.webp"
  },
  en: {
    label: "English",
    flag: window.location.origin + "/assets/images/flags/us.webp"
  },
}

export default Language
